var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "app", attrs: { id: "app" } },
    [
      _c("router-view"),
      _vm.isShowMask ? _c("div", { staticClass: "logined-mask" }) : _vm._e(),
      _c(
        "vuestic-modal",
        {
          ref: "complexPassword",
          staticStyle: { height: "100%", width: "60vw" },
          attrs: {
            show: _vm.complexPassword,
            okText: _vm._f("translate")("modal.confirm2"),
            okClass: "btn btn-primary btn-micro",
            cancelClass: "btn btn-secondary btn-micro",
            cancelText: _vm._f("translate")("modal.cancel2"),
            alignModal: "change-password-show",
            force: true,
          },
          on: {
            "update:show": function ($event) {
              _vm.complexPassword = $event
            },
          },
        },
        [
          _c("div", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v("Please Change Password"),
          ]),
          _c("div", [
            _c("form", [
              _c("div", { staticClass: "va-row" }, [
                _c("div", { staticClass: "flex xs12 md12" }, [
                  _c("fieldset", [
                    _c(
                      "div",
                      {
                        staticClass: "form-group with-icon-right",
                        class: {
                          "has-error": _vm.errors.has("currentPassword"),
                          valid: _vm.isFormFieldValid("currentPassword"),
                        },
                      },
                      [
                        _c("div", { staticClass: "input-group" }, [
                          (_vm.isCurOpen ? "text" : "password") === "checkbox"
                            ? _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.currentPassword,
                                    expression: "currentPassword",
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'",
                                  },
                                ],
                                attrs: {
                                  autocomplete: "off",
                                  maxlength: "50",
                                  required: "",
                                  name: "currentPassword",
                                  "data-vv-as": "Current Password",
                                  onkeyup: "value=value.replace(/\\s/g,'')",
                                  onkeydown: "value=value.replace(/\\s/g,'')",
                                  type: "checkbox",
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.currentPassword)
                                    ? _vm._i(_vm.currentPassword, null) > -1
                                    : _vm.currentPassword,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.currentPassword,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.currentPassword = $$a.concat([
                                            $$v,
                                          ]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.currentPassword = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.currentPassword = $$c
                                    }
                                  },
                                },
                              })
                            : (_vm.isCurOpen ? "text" : "password") === "radio"
                            ? _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.currentPassword,
                                    expression: "currentPassword",
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'",
                                  },
                                ],
                                attrs: {
                                  autocomplete: "off",
                                  maxlength: "50",
                                  required: "",
                                  name: "currentPassword",
                                  "data-vv-as": "Current Password",
                                  onkeyup: "value=value.replace(/\\s/g,'')",
                                  onkeydown: "value=value.replace(/\\s/g,'')",
                                  type: "radio",
                                },
                                domProps: {
                                  checked: _vm._q(_vm.currentPassword, null),
                                },
                                on: {
                                  change: function ($event) {
                                    _vm.currentPassword = null
                                  },
                                },
                              })
                            : _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.currentPassword,
                                    expression: "currentPassword",
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'",
                                  },
                                ],
                                attrs: {
                                  autocomplete: "off",
                                  maxlength: "50",
                                  required: "",
                                  name: "currentPassword",
                                  "data-vv-as": "Current Password",
                                  onkeyup: "value=value.replace(/\\s/g,'')",
                                  onkeydown: "value=value.replace(/\\s/g,'')",
                                  type: _vm.isCurOpen ? "text" : "password",
                                },
                                domProps: { value: _vm.currentPassword },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.currentPassword = $event.target.value
                                  },
                                },
                              }),
                          _c("i", {
                            staticClass:
                              "fa fa-exclamation-triangle error-icon icon-right input-icon",
                          }),
                          _c("i", {
                            staticClass:
                              "fa fa-check valid-icon icon-right input-icon",
                          }),
                          _c(
                            "label",
                            {
                              staticClass: "control-label",
                              attrs: { for: "currentPassword" },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm._f("translate")("profile.cur_password")
                                ) + "："
                              ),
                            ]
                          ),
                          _c("i", { staticClass: "bar" }),
                          _c("div", { staticClass: "login-eye-password" }, [
                            !_vm.isCurOpen
                              ? _c("img", {
                                  attrs: { src: _vm.closeEye, alt: "" },
                                  on: {
                                    click: () => {
                                      _vm.isCurOpen = true
                                    },
                                  },
                                })
                              : _vm._e(),
                            _vm.isCurOpen
                              ? _c("img", {
                                  attrs: { src: _vm.openEye, alt: "" },
                                  on: {
                                    click: () => {
                                      _vm.isCurOpen = false
                                    },
                                  },
                                })
                              : _vm._e(),
                          ]),
                          _c(
                            "small",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.errors.has("currentPassword"),
                                  expression: "errors.has('currentPassword')",
                                },
                              ],
                              staticClass: "help text-danger",
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.errors.first("currentPassword"))
                              ),
                            ]
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "form-group with-icon-right",
                        class: {
                          "has-error": _vm.errors.has("newPassword"),
                          valid: _vm.isFormFieldValid("newPassword"),
                        },
                      },
                      [
                        _c("div", { staticClass: "input-group" }, [
                          (_vm.isNewOpen ? "text" : "password") === "checkbox"
                            ? _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.newPassword,
                                    expression: "newPassword",
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'",
                                  },
                                ],
                                attrs: {
                                  autocomplete: "off",
                                  maxlength: "50",
                                  required: "",
                                  name: "newPassword",
                                  "data-vv-as": "New Password",
                                  onkeyup: "value=value.replace(/\\s/g,'')",
                                  onkeydown: "value=value.replace(/\\s/g,'')",
                                  type: "checkbox",
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.newPassword)
                                    ? _vm._i(_vm.newPassword, null) > -1
                                    : _vm.newPassword,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.newPassword,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.newPassword = $$a.concat([$$v]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.newPassword = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.newPassword = $$c
                                    }
                                  },
                                },
                              })
                            : (_vm.isNewOpen ? "text" : "password") === "radio"
                            ? _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.newPassword,
                                    expression: "newPassword",
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'",
                                  },
                                ],
                                attrs: {
                                  autocomplete: "off",
                                  maxlength: "50",
                                  required: "",
                                  name: "newPassword",
                                  "data-vv-as": "New Password",
                                  onkeyup: "value=value.replace(/\\s/g,'')",
                                  onkeydown: "value=value.replace(/\\s/g,'')",
                                  type: "radio",
                                },
                                domProps: {
                                  checked: _vm._q(_vm.newPassword, null),
                                },
                                on: {
                                  change: function ($event) {
                                    _vm.newPassword = null
                                  },
                                },
                              })
                            : _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.newPassword,
                                    expression: "newPassword",
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'",
                                  },
                                ],
                                attrs: {
                                  autocomplete: "off",
                                  maxlength: "50",
                                  required: "",
                                  name: "newPassword",
                                  "data-vv-as": "New Password",
                                  onkeyup: "value=value.replace(/\\s/g,'')",
                                  onkeydown: "value=value.replace(/\\s/g,'')",
                                  type: _vm.isNewOpen ? "text" : "password",
                                },
                                domProps: { value: _vm.newPassword },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.newPassword = $event.target.value
                                  },
                                },
                              }),
                          _c("i", {
                            staticClass:
                              "fa fa-exclamation-triangle error-icon icon-right input-icon",
                          }),
                          _c("i", {
                            staticClass:
                              "fa fa-check valid-icon icon-right input-icon",
                          }),
                          _c(
                            "label",
                            {
                              staticClass: "control-label",
                              attrs: { for: "newPassword" },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm._f("translate")("profile.new_password")
                                ) + "："
                              ),
                            ]
                          ),
                          _c("i", { staticClass: "bar" }),
                          _c("div", { staticClass: "login-eye-password" }, [
                            !_vm.isNewOpen
                              ? _c("img", {
                                  attrs: { src: _vm.closeEye, alt: "" },
                                  on: {
                                    click: () => {
                                      _vm.isNewOpen = true
                                    },
                                  },
                                })
                              : _vm._e(),
                            _vm.isNewOpen
                              ? _c("img", {
                                  attrs: { src: _vm.openEye, alt: "" },
                                  on: {
                                    click: () => {
                                      _vm.isNewOpen = false
                                    },
                                  },
                                })
                              : _vm._e(),
                          ]),
                          _c(
                            "small",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.errors.has("newPassword"),
                                  expression: "errors.has('newPassword')",
                                },
                              ],
                              staticClass: "help text-danger",
                            },
                            [_vm._v(_vm._s(_vm.errors.first("newPassword")))]
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "form-group with-icon-right",
                        class: {
                          "has-error": _vm.errors.has("repeatNewPassword"),
                          valid: _vm.isFormFieldValid("repeatNewPassword"),
                        },
                        staticStyle: { "margin-bottom": "0!important" },
                      },
                      [
                        _c("div", { staticClass: "input-group" }, [
                          (_vm.isRepOpen ? "text" : "password") === "checkbox"
                            ? _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.repeatNewPassword,
                                    expression: "repeatNewPassword",
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'",
                                  },
                                ],
                                attrs: {
                                  autocomplete: "off",
                                  maxlength: "50",
                                  required: "",
                                  name: "repeatNewPassword",
                                  "data-vv-as": "Repeat New Password",
                                  onkeyup: "value=value.replace(/\\s/g,'')",
                                  onkeydown: "value=value.replace(/\\s/g,'')",
                                  type: "checkbox",
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.repeatNewPassword)
                                    ? _vm._i(_vm.repeatNewPassword, null) > -1
                                    : _vm.repeatNewPassword,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.repeatNewPassword,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.repeatNewPassword = $$a.concat([
                                            $$v,
                                          ]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.repeatNewPassword = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.repeatNewPassword = $$c
                                    }
                                  },
                                },
                              })
                            : (_vm.isRepOpen ? "text" : "password") === "radio"
                            ? _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.repeatNewPassword,
                                    expression: "repeatNewPassword",
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'",
                                  },
                                ],
                                attrs: {
                                  autocomplete: "off",
                                  maxlength: "50",
                                  required: "",
                                  name: "repeatNewPassword",
                                  "data-vv-as": "Repeat New Password",
                                  onkeyup: "value=value.replace(/\\s/g,'')",
                                  onkeydown: "value=value.replace(/\\s/g,'')",
                                  type: "radio",
                                },
                                domProps: {
                                  checked: _vm._q(_vm.repeatNewPassword, null),
                                },
                                on: {
                                  change: function ($event) {
                                    _vm.repeatNewPassword = null
                                  },
                                },
                              })
                            : _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.repeatNewPassword,
                                    expression: "repeatNewPassword",
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'",
                                  },
                                ],
                                attrs: {
                                  autocomplete: "off",
                                  maxlength: "50",
                                  required: "",
                                  name: "repeatNewPassword",
                                  "data-vv-as": "Repeat New Password",
                                  onkeyup: "value=value.replace(/\\s/g,'')",
                                  onkeydown: "value=value.replace(/\\s/g,'')",
                                  type: _vm.isRepOpen ? "text" : "password",
                                },
                                domProps: { value: _vm.repeatNewPassword },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.repeatNewPassword = $event.target.value
                                  },
                                },
                              }),
                          _c("i", {
                            staticClass:
                              "fa fa-exclamation-triangle error-icon icon-right input-icon",
                          }),
                          _c("i", {
                            staticClass:
                              "fa fa-check valid-icon icon-right input-icon",
                          }),
                          _c(
                            "label",
                            {
                              staticClass: "control-label",
                              attrs: { for: "repeatNewPassword" },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm._f("translate")("profile.repeat_password")
                                ) + "："
                              ),
                            ]
                          ),
                          _c("i", { staticClass: "bar" }),
                          _c("div", { staticClass: "login-eye-password" }, [
                            !_vm.isRepOpen
                              ? _c("img", {
                                  attrs: { src: _vm.closeEye, alt: "" },
                                  on: {
                                    click: () => {
                                      _vm.isRepOpen = true
                                    },
                                  },
                                })
                              : _vm._e(),
                            _vm.isRepOpen
                              ? _c("img", {
                                  attrs: { src: _vm.openEye, alt: "" },
                                  on: {
                                    click: () => {
                                      _vm.isRepOpen = false
                                    },
                                  },
                                })
                              : _vm._e(),
                          ]),
                          _c(
                            "small",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.errors.has("repeatNewPassword"),
                                  expression: "errors.has('repeatNewPassword')",
                                },
                              ],
                              staticClass: "help text-danger",
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.errors.first("repeatNewPassword"))
                              ),
                            ]
                          ),
                          _c("div", [
                            _c(
                              "small",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errorText,
                                    expression: "errorText",
                                  },
                                ],
                                staticClass: "help text-danger",
                                staticStyle: {
                                  display: "inline-block",
                                  "text-align": "justify",
                                  "word-break": "break-all",
                                  "letter-spacing": "0.8px",
                                },
                              },
                              [_vm._v(_vm._s(_vm.errorText))]
                            ),
                          ]),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "form-group with-icon-right",
                        staticStyle: { "margin-top": "10px" },
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.$t("t.newPasswordMustBe")) +
                            "\n              "
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]
      ),
      _c("multipleMerchant"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }